export const pwStates = [{ value: 'PW', label: 'PW' }]
